
import { Box, Divider, Grid2, Skeleton, Stack } from '@mui/material';
import { memo } from 'react';

import { Card } from '@shared/ui';

export const SkeletonClassList = memo(() => {
  return (
    <>
      <Grid2
        container
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
        }}
        spacing={2}
        marginLeft={2} // trùe đi gap của item cuối
      >
        {Array.from({ length: 8 }).map((_, index) => (
          <Grid2
            key={index}
            size={{
              xs: 12,
              sm: 6,
              md: 4,
              lg: 3,
              xl: 2.4,
            }}
          >
            <Card
              title={
                <Stack flexDirection='row' justifyContent='space-between' marginTop={1} width='100%'>
                  <Stack flexDirection='row' gap={1}>
                    {/* Icon */}
                    <Skeleton variant='rounded' width={40} height={40} />

                    <Box>
                      {/* Chip */}
                      <Skeleton variant='rounded' width={80} height={20} />

                      {/* Title */}
                      <Skeleton variant='text' width={180} height={24} sx={{ marginTop: 0.5 }} />
                    </Box>
                  </Stack>
                </Stack>
              }
            >
              {/* PersonAvatarLists */}
              <Stack direction='row' spacing={1} marginBottom={2}>
                {Array.from({ length: 4 }).map((_, index) => (
                  <Skeleton key={index} variant='circular' width={32} height={32} />
                ))}
              </Stack>

              {/* ClassInformation */}
              <Stack spacing={0.5}>
                <Skeleton variant='text' width='60%' />
                <Skeleton variant='text' width='80%' />
                <Skeleton variant='text' width='50%' />
              </Stack>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    </>
  );
});

